<div class="padding padding-top-25 full-height">
  <mat-card>
    <mat-card-content>
      <div class="flex-container-space-between">
        <div class="flex-item">
          <h3>{{ 'orderDetails.orderDetails' | transloco }}</h3>
        </div>
      </div>
      <div class="flex-container">
        <span class="flex-item">{{ 'orderDetails.referenceNumber' | transloco }}</span>
        <span class="flex-item-2 flex-container-vertical-center">
          <b>{{ order.referenceNumber }}</b>
          <lib-copy-to-clipboard [value]="order.id" [tooltip]="'Copy Order ID'" style="margin-left: 5px;"></lib-copy-to-clipboard>
        </span>

        <span class="flex-item">{{ 'orderDetails.dateRequested' | transloco }}</span>
        <span class="flex-item-2">{{ order.dateRequested | localizedDate}}</span>
      </div>
      <div class="flex-container">
        <span class="flex-item">{{ 'orderDetails.status' | transloco }}</span>
        <span class="flex-item-2 bold">{{ order.orderStatusTypeID | enumLabel:'orderStatusType' }}</span>

        <span class="flex-item">{{ 'orderDetails.statusUpdated' | transloco }}</span>
        <span class="flex-item-2">{{ order.orderStatusUpdatedDate | localizedDate}}</span>
      </div>
      <div class="flex-container">
        <span class="flex-item">{{ 'orderDetails.jurisdiction' | transloco }}</span>
        <span class="flex-item-2">{{ order.jurisdiction | jurisdictionLabel:order.country:order.displayJurisdiction }}</span>

        <span class="flex-item">{{ 'orderDetails.country' | transloco }}</span>
        <span class="flex-item-2">{{ order.country | countryLabel }}</span>
      </div>
      @if (order.lien?.qcFormTypeID) {
        <div class="flex-container">
          <span class="flex-item">{{ 'orderDetails.qcFormType' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-qc-form-text">{{ order.lien!.qcFormTypeID! }}</span>
          <span class="flex-item"></span>
          <span class="flex-item-2"></span>
        </div>
      }
      <div class="flex-container">
        <span class="flex-item">{{ 'orderDetails.orderId' | transloco }}</span>
        <span class="flex-item-2">{{ order.id }}</span>

        <span class="flex-item">{{ 'orderDetails.orderGroup' | transloco }}</span>
        <span class="flex-item-2"><button mat-flat-button color="accent" (click)="openOrderHistory()">{{
        order.orderGroup?.id }}</button></span>
      </div>

      @if (shouldShowUserDetails) {
        <div class="margin-top-bottom-15">
          <mat-divider></mat-divider>
        </div>
      }

      <div class="flex-container">
        <lib-order-requesting-user-details [order]="order" [orderMetaData]="orderMetaData" class="flex-item">
        </lib-order-requesting-user-details>
        @if (order.id && shouldShowExternalOrderDetails) {
          <lib-external-order-details
            [isLockedByMe]="isLockedByMe" [externalOrderDetails]="externalOrderNumber!"
            (saveExternalOrderNumberEvent)="handleSaveExternalOrderNumberEvent($event)" class="flex-item">
          </lib-external-order-details>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>